"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLegalConsentDefaultSettings = fetchLegalConsentDefaultSettings;

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _fetchConsentCopy = _interopRequireDefault(require("SharedLegalStrings/consent/fetchConsentCopy"));

function recieveLegalConsentDefaultSettings(legalConsentSettings) {
  return {
    type: _ActionTypes.RECEIVE_LEGAL_CONSENT_SETTINGS,
    payload: legalConsentSettings
  };
}

function errorLegalConsentDefaultSettings(error) {
  return {
    type: _ActionTypes.ERROR_LEGAL_CONSENT_SETTINGS,
    payload: error,
    error: true
  };
}

function fetchLegalConsentDefaultSettings() {
  return function (dispatch) {
    return (0, _fetchConsentCopy.default)().then(function (response) {
      dispatch(recieveLegalConsentDefaultSettings(response));
    }, function (error) {
      dispatch(errorLegalConsentDefaultSettings(error.xhr));
    }).done();
  };
}